import React, { useEffect, useState } from "react";
import { Plus, Users } from "lucide-react";
import client from "../lib/api";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

const SweetCard = ({ sweet }) => {
  const { addItem } = useCart();
  const [size, setSize] = useState(sweet.sizes[0]);
  const add = () => {
    addItem({ id: `${sweet.id}-${size.people}`, name: `${sweet.name} (${size.people} people)`, price: size.price, image: sweet.image });
    toast.success("Added to cart", { description: `${sweet.name} · ${size.people} people` });
  };
  return (
    <div className="rounded-2xl bg-[#f6ece0] overflow-hidden shadow-sm">
      <img src={sweet.image} alt={sweet.name} className="w-full h-48 object-cover" loading="lazy" />
      <div className="p-4">
        <h3 className="font-heading text-xl font-bold text-[#2c1e12]">{sweet.name}</h3>
        <p className="text-sm text-[#8a7458] mt-1">{sweet.desc}</p>
        <div className="flex gap-2 mt-3">
          {sweet.sizes.map((s) => (
            <button key={s.people} onClick={() => setSize(s)}
              className={`flex-1 rounded-xl py-2 text-sm font-medium flex flex-col items-center transition-colors ${
                size.people === s.people ? "bg-[#9a4a2f] text-white" : "bg-[#efe3cd] text-[#4a3524] hover:bg-[#e6d6b8]"
              }`}>
              <span className="flex items-center gap-1"><Users className="h-3.5 w-3.5" />{s.people}</span>
              <span className="text-xs opacity-90">${s.price.toFixed(2)}</span>
            </button>
          ))}
        </div>
        <button onClick={add} className="mt-3 w-full inline-flex items-center justify-center gap-1.5 rounded-full bg-[#9a4a2f] hover:bg-[#853e26] text-white text-sm font-semibold px-4 py-2.5 transition-colors">
          <Plus className="h-4 w-4" /> Add Box — ${size.price.toFixed(2)}
        </button>
      </div>
    </div>
  );
};

const Sweets = () => {
  const [sweets, setSweets] = useState([]);
  useEffect(() => { client.get("/sweets").then((r) => setSweets(r.data.sweets)).catch(() => {}); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 pt-20 pb-24">
      <h1 className="font-heading text-4xl font-bold text-[#2c1e12]">Sweets & Desserts</h1>
      <p className="text-[#8a7458] mt-1">Premium traditional Serbian desserts — by the box for 10, 20 or 30 people.</p>
      <div className="grid sm:grid-cols-2 gap-4 mt-5">
        {sweets.map((s) => <SweetCard key={s.id} sweet={s} />)}
      </div>
    </div>
  );
};

export default Sweets;
